import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const RECEIVED_OPPORTUNITY_COUNT = 'RECEIVED_OPPORTUNITY_COUNT';

const getOpportunityCount = () => (
  dispatch => (
    axios.get('/api/leads/count-opportunities').then((response) => {
      dispatch({
        type: RECEIVED_OPPORTUNITY_COUNT,
        count: response.data.count,
      });
    }).catch((error) => {
      store.dispatch(addError({
        text: 'Could not get opportunity count',
        originalError: error,
      }));
    })
  )
);

export default getOpportunityCount;
